export default () => {
    return (map, nodes) => {
        const {canDesignWf, designWf} = map.commands
        const ns = canDesignWf(nodes)

        if (0 === ns.length) {
            return null
        }

        return [
            {
                label: '编辑',
                onClick: () => designWf(ns),
            },
        ]
    }
}
